module.exports = "https://www.gc-pro.gnp.com.mx/97c725eeb7daaf163dfa1777e7b84bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/retenciones/01.png
// module id = 1059
// module chunks = 0 1